
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface FrontendSocialGroupType {
  id: string;
  name: { ar: string; en: string };
  description: { ar: string; en: string };
  type: "whatsapp" | "telegram";
  link: string;
  members: number;
  image_url?: string | null;
}

interface SocialGroupDB {
  id: string;
  name_ar: string;
  name_en: string;
  description_ar: string;
  description_en: string;
  type: string;
  link: string;
  members: number;
  image_url: string | null;
}

const mapDBToGroup = (dbGroup: SocialGroupDB): FrontendSocialGroupType => ({
  id: dbGroup.id,
  name: { ar: dbGroup.name_ar, en: dbGroup.name_en },
  description: { ar: dbGroup.description_ar, en: dbGroup.description_en },
  type: dbGroup.type as "whatsapp" | "telegram",
  link: dbGroup.link,
  members: dbGroup.members,
  image_url: dbGroup.image_url,
});

export const useFrontendSocialGroups = () => {
  const [groups, setGroups] = useState<FrontendSocialGroupType[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchGroups = async () => {
      const { data, error } = await supabase
        .from('social_groups')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching groups:', error);
      } else {
        const mappedGroups = (data as SocialGroupDB[]).map(mapDBToGroup);
        setGroups(mappedGroups);
      }
      setIsLoading(false);
    };

    fetchGroups();
  }, []);

  return { groups, isLoading };
};
